import styled from 'styled-components';

export const Div = styled.div`
    position: relative;
    width: 300px;

    .input-file{
        position: relative;
        overflow: hidden;
    }

    input{
        width: 100%;
        border: 3px solid var(--n-color-4);
        border-radius: 3.5px;
        height: 54px;
        padding: 14px 16px;
        margin-bottom: 6px;
        position: relative;
    }

    label{
        position: absolute;
        left: 0;
        top: 0;
        font-size: ${props => props.activeItem ? '12px' : '16px'};
        top: ${props => props.activeItem ? '-6px' : '16px'};
        left: 14px;
        background: #fff;
        padding: 0px 5px;
        transition: all .3s ease;
        color: ${props => props.activeItem ? 'var(--color-5)' : 'var(--n-color-3)'};
        font-weight: 600;
        z-index: 10;
    }

    input.error{
        border: 3px solid red;
    }

    .extra-inf{
        font-size: 14px;
        padding-left: 16px;
        color: var(--color-5);
        font-weight: 600;
    }
    .errors{
        margin-bottom: 10px;
        font-size: 14px;
        padding-left: 16px;
        font-weight: 600;
        color: var(--color-3) !important;
    }

    .value-input{
        width: 294px;
        /* border: 3px solid var(--n-color-4); */
        border-radius: 3.5px;
        height: 48px;
        padding: 14px 16px;
        margin-bottom: 6px;
        background: #fff;
        position: absolute;
        left: 3px;
        top: 3px;
        cursor: pointer;
        overflow: hidden;
    }

    img, video{
        width: 300px;
        height: 200px;
    }
`;